import BotaoSubmit from './BotaoCadastro';
import React from 'react';

interface BotoesSalvarExcluirProps {
  isLoading: boolean;
  texto: string;
  textoLoading: string;
  id?: number | string;
  onExcluirClick: () => void;
  onSalvarEAdicionarOutros?: () => void;
  onSalvarEContinuar?: () => void;
}

const BotoesSalvarExcluir: React.FC<BotoesSalvarExcluirProps> = ({
  isLoading,
  texto,
  textoLoading,
  id,
  onExcluirClick,
  onSalvarEAdicionarOutros,
  onSalvarEContinuar
}) => {

  const temId = id !== undefined && id !== null && id !== '' && id !== 0;
  const botaoExcluir = temId ? (
    <button type="button" className='btn btn-outline-danger me-3' onClick={onExcluirClick} >
      Excluir
    </button>
  ) : null;

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div>
        {botaoExcluir}
      </div>
      <div className='d-flex gap-2'>
        {onSalvarEAdicionarOutros && (
          <button
            type="button"
            className='btn btn-outline-success'
            title='Grava as alterações e limpa a tela para adicionar outro registro.'
            onClick={onSalvarEAdicionarOutros}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Salvando...</span>
                {textoLoading}
              </>
            ) : (
              'Salvar e Adicionar Outro'
            )}
          </button>
        )}
        {onSalvarEContinuar && (
          <button
            type="button"
            className='btn btn-outline-success'
            title='Grava as alterações e mantém a tela para adicionar outro registro.'
            onClick={onSalvarEContinuar}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Salvando...</span>
                {textoLoading}
              </>
            ) : (
              'Salvar e Continuar'
            )}
          </button>
        )}
        <BotaoSubmit
          isLoading={isLoading}
          texto={texto.toUpperCase()}
          textoLoading={textoLoading}
          className='btn btn-success'
        />
      </div>
    </div>
  );
};

export default BotoesSalvarExcluir;